/**
 * Utilities for working with link documents
 * Provides functions for parsing and formatting link data
 */

export interface LinkData {
	title: string | null;
	url: string;
}

/**
 * Parses a link document description into a LinkData object
 * Falls back to default values if parsing fails
 */
export const parseLinkDescription = (description: string | null | undefined): LinkData => {
	if (!description) {
		return { title: null, url: '' };
	}

	try {
		const linkData = JSON.parse(description) as LinkData;
		return {
			title: linkData.title || null,
			url: linkData.url || '',
		};
	} catch (e) {
		console.error('Failed to parse link JSON:', e);
		return { title: null, url: '' };
	}
};

/**
 * Formats LinkData as a JSON string for storage
 */
export const formatLinkData = (linkData: LinkData): string => {
	return JSON.stringify({
		title: linkData.title?.trim() || null,
		url: linkData.url.trim(),
	});
};
